import { useState, useCallback } from "react";
import apiClient from "../api/apiClient";

export function useApi() {
  const [loadingCount, setLoadingCount] = useState(0);

  const loading = loadingCount > 0;
  const [error, setError] = useState(null);

  const request = useCallback(
    async ({ url, method = "GET", data, params, headers }) => {
      setLoadingCount((prev) => prev + 1);
      setError(null);

      try {
        const response = await apiClient.request({
          url,
          method,
          data,
          params,
          headers,
          withCredentials:true
        });

        return response;
      } catch (err) {
        // Extract readable message
        const readableError =
          err?.response?.data?.message || // Backend sent message
          err?.response?.data?.error || // Custom backend error
          err?.response?.data || // Full backend body
          err?.message || // Axios error message
          err ||
          "Unexpected error occurred"; // Safe fallback

        console.error("API ERROR:", readableError);

        setError(readableError);
        throw readableError;
      } finally {
        setLoadingCount((prev) => prev - 1);

      }
    },
    [],
  );

  return { request, loading, error };
}
